import styled from '@emotion/native';
import { GroupSecurity } from '@quromedical/fhir-common';
import { TabRouter, type Theme, ThemeProvider } from '@react-navigation/native';
import { Visible } from 'design-system';
import { Navigator, router, Slot } from 'expo-router';
import { useIsSmallerThan } from 'hooks/useResponsive';
import { useUserSession } from 'hooks/useUserSession';
import React, { useMemo } from 'react';
import { Platform } from 'react-native';

import {
  Bottombar,
  BottomNavigatorProvider,
  TopBar,
  Topbar,
} from './design-system';

export const adminVisiblePermissions = [GroupSecurity.Admin];

interface ResponsiveNavigatorProps {
  theme: Theme;
}

const Page = styled.View(({ theme }) => ({
  flex: 1,
  backgroundColor: theme.color.base,
}));

export const ResponsiveNavigator: React.FC<ResponsiveNavigatorProps> = ({
  theme,
}) => {
  const isSmall = useIsSmallerThan('md');
  const session = useUserSession();

  const isNative = Platform.OS !== 'web';

  const isMobileView = useMemo(() => isSmall || isNative, [isSmall, isNative]);
  const navigateToProfile = React.useCallback(() => {
    router.push('/profile');
  }, []);

  return (
    <BottomNavigatorProvider>
      <ThemeProvider value={theme}>
        <Navigator router={TabRouter}>
          <Visible if={!isMobileView}>
            <Topbar />
          </Visible>
          <Page>
            <Visible if={isMobileView}>
              <TopBar
                name={session.user?.email}
                onProfilePress={navigateToProfile}
                onWardSelect={session.selectWard}
                wards={session.wards}
                ward={session.ward}
              />
            </Visible>
            <Slot />
          </Page>
          <Visible if={isMobileView}>
            <Bottombar />
          </Visible>
        </Navigator>
      </ThemeProvider>
    </BottomNavigatorProvider>
  );
};
